export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["检查地址"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入地址"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选择区块链"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["执行检查"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["低风险"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["中等风险"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["高风险"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["不在黑名单中"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["检查其他地址"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["下载 PDF"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["返回"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选择提供商"])}
}